<template>
  <v-form v-if="watchlistId && watchlistItem" ref="form" v-model="valid" class="fin-watchlist-notification">
    <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                 v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                 fluid>
      <v-row class="header pt-12 pb-5">
        <v-col>
          <h1>Limits einstellen</h1>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                 v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                 class="content pt-6"
                 fluid>
      <v-row>
        <v-col cols="12">
          <h2>{{ wlItem.instrument.name }}</h2>
        </v-col>

        <v-col cols="12" order="2" order-sm="1" sm="6">
          <p class="mb-2">Bitte benachrichtige mich, wenn folgende Limits erreicht sind:</p>
          <div style="display: flex;">
            <v-switch v-model="wlItem.alertActive"
                      :color="$finColors.primaryDark"
                      :false-value="false"
                      :label="wlItem.alertActive ? 'ja' : 'nein'"
                      :style="{marginRight: '40px'}"
                      :true-value="true"
                      class="mt-0 pt-0"
                      hide-details
                      inset/>
            <v-tooltip v-if="!wlItem.alertActive && wlItem.exceeded"
                       bottom
                       style="display: flex;">
              <template #activator="{ on, attrs }">
               <span v-if="wlItem.exceeded.timestamp"
                     style="display: block; margin-top: 2px;"
                     v-bind="attrs"
                     v-on="on">
                 <small>Deaktiviert am {{ wlItem.exceeded.timestamp | date }}</small>
               </span>
              </template>
              <span v-if="wlItem.exceeded.lowerLimit">
              Das Limit von {{
                  wlItem.exceeded.lowerLimit | finCurrency
                }} wurde am {{ wlItem.exceeded.timestamp | date }}
              mit dem Kurs {{ wlItem.exceeded.price | finCurrency }} unterschritten
            </span>
              <span v-if="wlItem.exceeded.upperLimit">
              Das Limit von {{
                  wlItem.exceeded.upperLimit | finCurrency
                }} wurde am {{ wlItem.exceeded.timestamp | date }}
              mit dem Kurs {{ wlItem.exceeded.price | finCurrency }} überschritten
            </span>
            </v-tooltip>
          </div>

          <v-row class="mt-8 mb-2" no-gutters>
            <v-col>
              <div style="max-width: 420px;">
                <h3 class="mb-0" style="display: inline-block;">Unteres Limit</h3>
                <v-btn :disabled="!wlItem.lowerLimit"
                       small
                       style="height: 16px; float: right;"
                       text
                       @click="wlItem.lowerLimit = null">
                  Limit löschen
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <fin-currency-field v-model="wlItem.lowerLimit"/>
          <v-text-field v-model="wlItem.lowerLimit"
                        :error-messages="noLimitSet ? 'Benachrichtigung deaktivieren oder Wert eingeben':''"
                        :hint="differenceLow ? 'entspricht einer Differenz von ' + '<span class=differenceLow>'+ differenceLow + '</span>' : ''"
                        :rules="[rules.lowerLimit]"
                        append-icon="mdi-currency-eur lower-icon"
                        class="lowerLimit"
                        dense
                        outlined
                        persistent-hint
                        single-line
                        type="number"
          >
            <template #message="{ message }">
              <span v-html="message"/>
            </template>
          </v-text-field>

          <v-row class="mt-8 mb-2" no-gutters>
            <v-col>
              <div style="max-width: 420px;">
                <h3 class="mb-0" style="display: inline-block;">Oberes Limit</h3>
                <v-btn :disabled="!wlItem.upperLimit"
                       small
                       style="height: 16px; float: right;"
                       text
                       @click="wlItem.upperLimit = null">
                  Limit löschen
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <fin-currency-field v-model="wlItem.upperLimit"/>
          <v-text-field v-model="wlItem.upperLimit"
                        :error-messages="noLimitSet ? 'Benachrichtigung deaktivieren oder Wert eingeben':''"
                        :hint="differenceUp ? 'entspricht einer Differenz von ' + '<span class=differenceUp>'+ differenceUp + '</span>' : ''"
                        :rules="[rules.upperLimit]"
                        append-icon="mdi-currency-eur upper-icon"
                        class="upperLimit"
                        dense
                        outlined
                        persistent-hint
                        single-line
                        type="number"
          >
            <template #message="{ message }">
              <span v-html="message"/>
            </template>
          </v-text-field>

          <v-btn :to="{name: 'watchlistDetails', params: {id: watchlistId}}"
                 class="mr-6 mt-8 mb-3"
                 color="fin-color-primary-dark"
                 exact
                 outlined>
            Abbrechen
          </v-btn>
          <v-btn :disabled="!valid || noLimitSet || !dataChanged"
                 class="mt-8 mb-3 submitBtn"
                 color="fin-color-primary-dark"
                 dark
                 @click="submitNotification">
            Übernehmen
          </v-btn>
        </v-col>

        <v-col cols="12" md="3" order="1" order-sm="2" sm="6">
          <div style="display: flex;">
            <fin-portfolio-value-change :addSign="false"
                                        :force-show-hint="true"
                                        :to="wlItem.instrument.latestPrice.price"
                                        v-style:margin="$vuetify.breakpoint.xs ? '0 auto' : '0'"
                                        title="Aktueller Wert"
            >
              <template #portfolioHint>
                <fin-time-ago :datetime="wlItem.instrument.latestPrice.timestamp"
                              :limit="1000*60*60*24"
                              :prepend-text="exchangeName ? 'Börse ' + exchangeName + ': ' : ''"
                              style="font-size: 1em; font-weight: normal;"/>
              </template>
            </fin-portfolio-value-change>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import FinCurrencyField from "@/components/common/CurrencyField"
import FinPortfolioValueChange from "@/components/pages/myPortfolio/PortfolioValueChange"
import {finUserAPI} from "@/js/finAPI"

export default {
  name: "FinWatchlistNotificationDisplay",
  components: {FinCurrencyField, FinPortfolioValueChange},
  props: {
    watchlistId: {
      type: String,
      required: true,
    },
    watchlistItem: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      valid: false,
      wlItem: this.watchlistItem,
      watchlistItemOriginal: Object.assign({}, this.watchlistItem),
    }
  },
  computed: {
    dataChanged() { // Check if user made any changes to limits / alerts
      return (
        this.wlItem.lowerLimit !== this.watchlistItemOriginal.lowerLimit ||
        this.wlItem.upperLimit !== this.watchlistItemOriginal.upperLimit ||
        this.wlItem.alertActive !== this.watchlistItemOriginal.alertActive)
    },
    noLimitSet() { //
      return (this.wlItem.alertActive && !this.wlItem.lowerLimit && !this.wlItem.upperLimit)
    },
    exchangeName() {
      return this.wlItem.instrument.latestPrice.exchangeName
    },
    differenceLow() {
      if (this.wlItem?.lowerLimit && this.wlItem?.instrument) {
        return this.$options.filters.percent(100 / this.wlItem.instrument.latestPrice.price * this.wlItem.lowerLimit - 100)
      }
      return null
    },
    differenceUp() {
      if (this.wlItem?.upperLimit && this.wlItem?.instrument) {
        return this.$options.filters.percent(100 / this.wlItem.instrument.latestPrice.price * this.wlItem.upperLimit - 100)
      }
      return null
    },
    rules() {
      return {
        upperLimit: v => !v || v > this.wlItem.instrument.latestPrice.price || "Das obere Limit muss über dem aktuellen Kurs liegen.",
        lowerLimit: v => !v || v < this.wlItem.instrument.latestPrice.price || "Das untere Limit muss unter dem aktuellen Kurs liegen.",
      }
    },
  },
  methods: {
    async submitNotification() {
      try {
        await finUserAPI.updateWatchlistEntry(
          this.wlItem.watchlistId,
          this.wlItem.instrumentId,
          this.wlItem.alertActive,
          {
            lowerLimit: this.wlItem.lowerLimit || null,
            upperLimit: this.wlItem.upperLimit || null
          })
        await this.$router.push({name: 'watchlistDetails', params: {id: this.watchlistId}})
        this.$toasted.global.finToast({
          message: `Die Limiteinstellungen wurden erfolgreich übernommen.`,
          type: 'success'
        })
      } catch (error) {
        console.log("error submitting limits", error)
        this.$toasted.global.finToast({
          message: 'Ein Fehler ist beim Speichern der Limits aufgetreten. Lade die Seite neu und versuche es bitte erneut..',
          type: 'error'
        })
      }
    },
  },
  mounted() {
    const form = this.$refs.form
    if (form) {
      this.valid = form.validate()
    }
  }
}
</script>

<style lang="scss" scoped>
// TODO
h2 {
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
}

// TODO
h3 {
  font-family: $body-font-family !important;
  font-size: 16px;
  font-weight: bold;
}

p {
  font-size: 16px;
}

.content {
  background-color: #ffffff;

  .current-value {
    font-size: 12px;
    font-weight: 600;
    font-family: $body-font-family !important;
    line-height: 1.17;
  }

  .current-value-close {
    font-size: 42px;
    font-weight: bold;
    margin: 0;
  }

  ::v-deep span.differenceUp {
    color: $fin-color-accent-green;
  }

  ::v-deep span.differenceLow {
    color: $fin-color-accent-red;
  }

  ::v-deep .v-text-field {
    width: 420px;
  }

  ::v-deep .v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
    color: $fin-color-primary-dark;
    top: 18px;
    font-size: 14px;
    line-height: 1.14;
    max-width: 400px;
  }

  .notification-button-inactive {
    opacity: 0.38;
    font-weight: bold;
  }

  ::v-deep .v-btn.theme--dark:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #02073a !important;
  }

  ::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
    padding: 0;

    .theme--light.v-messages {
      font-size: 14px;
      color: $fin-color-primary-dark;
    }
  }

  ::v-deep .upperLimit .v-input__slot,
  ::v-deep .lowerLimit .v-input__slot {
    display: none;
  }
}

::v-deep .v-input--switch .v-label {
  display: contents;
}
</style>
